<template>
  <div class="code" :style="{zIndex: 0}">
    <textarea ref="mirrorcode" class="codetext" v-model="code"></textarea>
  </div>
</template>

<script>
import CodeMirror from 'codemirror/lib/codemirror'
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    wangEditor: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      code: this.value || '',
      cmeditor: null
    }
  },
  watch: {
    value(val) {
      if (!(this.wangEditor?.toggle)) {
        this.cmeditor.setValue(val)
      }
    }
  },
  mounted() {
    const editor = CodeMirror.fromTextArea(this.$refs.mirrorcode, {
      theme: 'theme',
      lineNumbers: true,
      mode: 'text/html'
    })
    editor.on('change', () => {
      this.code = editor.getValue()
      this.$emit('change', this.code)
    })
    editor.setSize('100%', 199)

    this.cmeditor = editor
  }
}
</script>

<style lang="scss" scoped>
.code {
  position: absolute;
  left: 0;
  top: 41px;
  width: 100%;
  height: 201px;
  background-color: #FFF;
  border:1px solid #c9d8db;
  .codetext {
    height: 100%;
  }
}
</style>
